import { RISK_CODES } from './Constants';

export function hasCommitteeRiskTabContent(
  riskData: unknown,
  options: { isUruguayEnabled: boolean },
): boolean {
  if (!Array.isArray(riskData) || riskData.length === 0) {
    return false;
  }

  if (!options.isUruguayEnabled) {
    return true;
  }

  return riskData.some((entry) => {
    if (entry?.risk_code === RISK_CODES.bpb) {
      return true;
    }
    if (entry?.risk_code === RISK_CODES.lideco) {
      return (entry.indicators?.length ?? 0) > 0;
    }
    return false;
  });
}
